import * as types from './mutation-types'
export default {
  [types.SET_SLACK_USERS](state, slackUsers) {
    state.slackUsers = slackUsers
  },
}
